import { jsx as m, jsxs as H } from "react/jsx-runtime";
import * as x from "react";
import { useState as J, useEffect as Q, useId as he, useCallback as U, createElement as xe } from "react";
import { a as pe, c as W } from "./index-eoE_jzLb.js";
import { u as K } from "./index-DoOsnuB6.js";
import { P as O, c as ge } from "./index-D8UDu4KA.js";
import { c as Se, u as ye } from "./index-Dn75bnUs.js";
import { u as be } from "./index-BZPx6jYI.js";
import { u as ve } from "./index-4vbonZJj.js";
import { c as $ } from "./clsx-OuTLNxxd.js";
import { I as Z } from "./Input-BK8CApGi.js";
import { L as _e } from "./Label-C6Cio33A.js";
import './Slider.css';function ee(e, [t, r]) {
  return Math.min(r, Math.max(t, e));
}
var te = ["PageUp", "PageDown"], ne = ["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"], oe = {
  "from-left": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-right": ["Home", "PageDown", "ArrowDown", "ArrowRight"],
  "from-bottom": ["Home", "PageDown", "ArrowDown", "ArrowLeft"],
  "from-top": ["Home", "PageDown", "ArrowUp", "ArrowLeft"]
}, N = "Slider", [Y, we, ze] = Se(N), [ie] = ge(N, [
  ze
]), [Ce, L] = ie(N), re = x.forwardRef(
  (e, t) => {
    const {
      name: r,
      min: o = 0,
      max: a = 100,
      step: l = 1,
      orientation: s = "horizontal",
      disabled: i = !1,
      minStepsBetweenThumbs: c = 0,
      defaultValue: f = [o],
      value: y,
      onValueChange: n = () => {
      },
      onValueCommit: u = () => {
      },
      inverted: S = !1,
      form: C,
      ..._
    } = e, p = x.useRef(/* @__PURE__ */ new Set()), h = x.useRef(0), z = s === "horizontal" ? ke : Pe, [b = [], d] = pe({
      prop: y,
      defaultProp: f,
      onChange: (g) => {
        var k;
        (k = [...p.current][h.current]) == null || k.focus(), n(g);
      }
    }), v = x.useRef(b);
    function B(g) {
      const R = De(b, g);
      I(g, R);
    }
    function M(g) {
      I(g, h.current);
    }
    function A() {
      const g = v.current[h.current];
      b[h.current] !== g && u(b);
    }
    function I(g, R, { commit: k } = { commit: !1 }) {
      const V = Ne(l), F = Me(Math.round((g - o) / l) * l + o, V), T = ee(F, [o, a]);
      d((E = []) => {
        const D = Ve(E, T, R);
        if (We(D, c * l)) {
          h.current = D.indexOf(T);
          const q = String(D) !== String(E);
          return q && k && u(D), q ? D : E;
        } else
          return E;
      });
    }
    return /* @__PURE__ */ m(
      Ce,
      {
        scope: e.__scopeSlider,
        name: r,
        disabled: i,
        min: o,
        max: a,
        valueIndexToChangeRef: h,
        thumbs: p.current,
        values: b,
        orientation: s,
        form: C,
        children: /* @__PURE__ */ m(Y.Provider, { scope: e.__scopeSlider, children: /* @__PURE__ */ m(Y.Slot, { scope: e.__scopeSlider, children: /* @__PURE__ */ m(
          z,
          {
            "aria-disabled": i,
            "data-disabled": i ? "" : void 0,
            ..._,
            ref: t,
            onPointerDown: W(_.onPointerDown, () => {
              i || (v.current = b);
            }),
            min: o,
            max: a,
            inverted: S,
            onSlideStart: i ? void 0 : B,
            onSlideMove: i ? void 0 : M,
            onSlideEnd: i ? void 0 : A,
            onHomeKeyDown: () => !i && I(o, 0, { commit: !0 }),
            onEndKeyDown: () => !i && I(a, b.length - 1, { commit: !0 }),
            onStepKeyDown: ({ event: g, direction: R }) => {
              if (!i) {
                const F = te.includes(g.key) || g.shiftKey && ne.includes(g.key) ? 10 : 1, T = h.current, E = b[T], D = l * F * R;
                I(E + D, T, { commit: !0 });
              }
            }
          }
        ) }) })
      }
    );
  }
);
re.displayName = N;
var [se, ae] = ie(N, {
  startEdge: "left",
  endEdge: "right",
  size: "width",
  direction: 1
}), ke = x.forwardRef(
  (e, t) => {
    const {
      min: r,
      max: o,
      dir: a,
      inverted: l,
      onSlideStart: s,
      onSlideMove: i,
      onSlideEnd: c,
      onStepKeyDown: f,
      ...y
    } = e, [n, u] = x.useState(null), S = K(t, (z) => u(z)), C = x.useRef(void 0), _ = ye(a), p = _ === "ltr", h = p && !l || !p && l;
    function P(z) {
      const b = C.current || n.getBoundingClientRect(), d = [0, b.width], B = G(d, h ? [r, o] : [o, r]);
      return C.current = b, B(z - b.left);
    }
    return /* @__PURE__ */ m(
      se,
      {
        scope: e.__scopeSlider,
        startEdge: h ? "left" : "right",
        endEdge: h ? "right" : "left",
        direction: h ? 1 : -1,
        size: "width",
        children: /* @__PURE__ */ m(
          le,
          {
            dir: _,
            "data-orientation": "horizontal",
            ...y,
            ref: S,
            style: {
              ...y.style,
              "--radix-slider-thumb-transform": "translateX(-50%)"
            },
            onSlideStart: (z) => {
              const b = P(z.clientX);
              s == null || s(b);
            },
            onSlideMove: (z) => {
              const b = P(z.clientX);
              i == null || i(b);
            },
            onSlideEnd: () => {
              C.current = void 0, c == null || c();
            },
            onStepKeyDown: (z) => {
              const d = oe[h ? "from-left" : "from-right"].includes(z.key);
              f == null || f({ event: z, direction: d ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), Pe = x.forwardRef(
  (e, t) => {
    const {
      min: r,
      max: o,
      inverted: a,
      onSlideStart: l,
      onSlideMove: s,
      onSlideEnd: i,
      onStepKeyDown: c,
      ...f
    } = e, y = x.useRef(null), n = K(t, y), u = x.useRef(void 0), S = !a;
    function C(_) {
      const p = u.current || y.current.getBoundingClientRect(), h = [0, p.height], z = G(h, S ? [o, r] : [r, o]);
      return u.current = p, z(_ - p.top);
    }
    return /* @__PURE__ */ m(
      se,
      {
        scope: e.__scopeSlider,
        startEdge: S ? "bottom" : "top",
        endEdge: S ? "top" : "bottom",
        size: "height",
        direction: S ? 1 : -1,
        children: /* @__PURE__ */ m(
          le,
          {
            "data-orientation": "vertical",
            ...f,
            ref: n,
            style: {
              ...f.style,
              "--radix-slider-thumb-transform": "translateY(50%)"
            },
            onSlideStart: (_) => {
              const p = C(_.clientY);
              l == null || l(p);
            },
            onSlideMove: (_) => {
              const p = C(_.clientY);
              s == null || s(p);
            },
            onSlideEnd: () => {
              u.current = void 0, i == null || i();
            },
            onStepKeyDown: (_) => {
              const h = oe[S ? "from-bottom" : "from-top"].includes(_.key);
              c == null || c({ event: _, direction: h ? -1 : 1 });
            }
          }
        )
      }
    );
  }
), le = x.forwardRef(
  (e, t) => {
    const {
      __scopeSlider: r,
      onSlideStart: o,
      onSlideMove: a,
      onSlideEnd: l,
      onHomeKeyDown: s,
      onEndKeyDown: i,
      onStepKeyDown: c,
      ...f
    } = e, y = L(N, r);
    return /* @__PURE__ */ m(
      O.span,
      {
        ...f,
        ref: t,
        onKeyDown: W(e.onKeyDown, (n) => {
          n.key === "Home" ? (s(n), n.preventDefault()) : n.key === "End" ? (i(n), n.preventDefault()) : te.concat(ne).includes(n.key) && (c(n), n.preventDefault());
        }),
        onPointerDown: W(e.onPointerDown, (n) => {
          const u = n.target;
          u.setPointerCapture(n.pointerId), n.preventDefault(), y.thumbs.has(u) ? u.focus() : o(n);
        }),
        onPointerMove: W(e.onPointerMove, (n) => {
          n.target.hasPointerCapture(n.pointerId) && a(n);
        }),
        onPointerUp: W(e.onPointerUp, (n) => {
          const u = n.target;
          u.hasPointerCapture(n.pointerId) && (u.releasePointerCapture(n.pointerId), l(n));
        })
      }
    );
  }
), ce = "SliderTrack", de = x.forwardRef(
  (e, t) => {
    const { __scopeSlider: r, ...o } = e, a = L(ce, r);
    return /* @__PURE__ */ m(
      O.span,
      {
        "data-disabled": a.disabled ? "" : void 0,
        "data-orientation": a.orientation,
        ...o,
        ref: t
      }
    );
  }
);
de.displayName = ce;
var j = "SliderRange", ue = x.forwardRef(
  (e, t) => {
    const { __scopeSlider: r, ...o } = e, a = L(j, r), l = ae(j, r), s = x.useRef(null), i = K(t, s), c = a.values.length, f = a.values.map(
      (u) => fe(u, a.min, a.max)
    ), y = c > 1 ? Math.min(...f) : 0, n = 100 - Math.max(...f);
    return /* @__PURE__ */ m(
      O.span,
      {
        "data-orientation": a.orientation,
        "data-disabled": a.disabled ? "" : void 0,
        ...o,
        ref: i,
        style: {
          ...e.style,
          [l.startEdge]: y + "%",
          [l.endEdge]: n + "%"
        }
      }
    );
  }
);
ue.displayName = j;
var X = "SliderThumb", me = x.forwardRef(
  (e, t) => {
    const r = we(e.__scopeSlider), [o, a] = x.useState(null), l = K(t, (i) => a(i)), s = x.useMemo(
      () => o ? r().findIndex((i) => i.ref.current === o) : -1,
      [r, o]
    );
    return /* @__PURE__ */ m(Ie, { ...e, ref: l, index: s });
  }
), Ie = x.forwardRef(
  (e, t) => {
    const { __scopeSlider: r, index: o, name: a, ...l } = e, s = L(X, r), i = ae(X, r), [c, f] = x.useState(null), y = K(t, (P) => f(P)), n = c ? s.form || !!c.closest("form") : !0, u = ve(c), S = s.values[o], C = S === void 0 ? 0 : fe(S, s.min, s.max), _ = Be(o, s.values.length), p = u == null ? void 0 : u[i.size], h = p ? He(p, C, i.direction) : 0;
    return x.useEffect(() => {
      if (c)
        return s.thumbs.add(c), () => {
          s.thumbs.delete(c);
        };
    }, [c, s.thumbs]), /* @__PURE__ */ H(
      "span",
      {
        style: {
          transform: "var(--radix-slider-thumb-transform)",
          position: "absolute",
          [i.startEdge]: `calc(${C}% + ${h}px)`
        },
        children: [
          /* @__PURE__ */ m(Y.ItemSlot, { scope: e.__scopeSlider, children: /* @__PURE__ */ m(
            O.span,
            {
              role: "slider",
              "aria-label": e["aria-label"] || _,
              "aria-valuemin": s.min,
              "aria-valuenow": S,
              "aria-valuemax": s.max,
              "aria-orientation": s.orientation,
              "data-orientation": s.orientation,
              "data-disabled": s.disabled ? "" : void 0,
              tabIndex: s.disabled ? void 0 : 0,
              ...l,
              ref: y,
              style: S === void 0 ? { display: "none" } : e.style,
              onFocus: W(e.onFocus, () => {
                s.valueIndexToChangeRef.current = o;
              })
            }
          ) }),
          n && /* @__PURE__ */ m(
            Re,
            {
              name: a ?? (s.name ? s.name + (s.values.length > 1 ? "[]" : "") : void 0),
              form: s.form,
              value: S
            },
            o
          )
        ]
      }
    );
  }
);
me.displayName = X;
var Re = (e) => {
  const { value: t, ...r } = e, o = x.useRef(null), a = be(t);
  return x.useEffect(() => {
    const l = o.current, s = window.HTMLInputElement.prototype, c = Object.getOwnPropertyDescriptor(s, "value").set;
    if (a !== t && c) {
      const f = new Event("input", { bubbles: !0 });
      c.call(l, t), l.dispatchEvent(f);
    }
  }, [a, t]), /* @__PURE__ */ m("input", { style: { display: "none" }, ...r, ref: o, defaultValue: t });
};
function Ve(e = [], t, r) {
  const o = [...e];
  return o[r] = t, o.sort((a, l) => a - l);
}
function fe(e, t, r) {
  const l = 100 / (r - t) * (e - t);
  return ee(l, [0, 100]);
}
function Be(e, t) {
  return t > 2 ? `Value ${e + 1} of ${t}` : t === 2 ? ["Minimum", "Maximum"][e] : void 0;
}
function De(e, t) {
  if (e.length === 1) return 0;
  const r = e.map((a) => Math.abs(a - t)), o = Math.min(...r);
  return r.indexOf(o);
}
function He(e, t, r) {
  const o = e / 2, l = G([0, 50], [0, o]);
  return (o - l(t) * r) * r;
}
function Ee(e) {
  return e.slice(0, -1).map((t, r) => e[r + 1] - t);
}
function We(e, t) {
  if (t > 0) {
    const r = Ee(e);
    return Math.min(...r) >= t;
  }
  return !0;
}
function G(e, t) {
  return (r) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const o = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + o * (r - e[0]);
  };
}
function Ne(e) {
  return (String(e).split(".")[1] || "").length;
}
function Me(e, t) {
  const r = Math.pow(10, t);
  return Math.round(e * r) / r;
}
var Ae = re, Te = de, Ke = ue, $e = me;
const Oe = "320px", Le = "600px", Fe = "1025px", Ue = "_output_1oxkz_56", Ye = "_sliderWrapper_1oxkz_74", je = "_label_1oxkz_86", Xe = "_labelContainer_1oxkz_90", Ge = "_controlsWrapper_1oxkz_95", qe = "_inputsContainer_1oxkz_102", Je = "_inputWrapper_1oxkz_109", Qe = "_sliderContainer_1oxkz_128", Ze = "_shouldShowBackground_1oxkz_134", et = "_track_1oxkz_139", tt = "_slider_1oxkz_74", nt = "_range_1oxkz_161", ot = "_thumb_1oxkz_168", it = "_noValue_1oxkz_181", rt = "_sliderInput_1oxkz_201", w = {
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  mobile: Oe,
  "mobile-wide": "480px",
  tablet: Le,
  "tablet-wide": "800px",
  desktop: Fe,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  "size-s": "_size-s_1oxkz_51",
  output: Ue,
  "size-m": "_size-m_1oxkz_62",
  sliderWrapper: Ye,
  label: je,
  labelContainer: Xe,
  controlsWrapper: Ge,
  inputsContainer: qe,
  inputWrapper: Je,
  sliderContainer: Qe,
  shouldShowBackground: Ze,
  track: et,
  slider: tt,
  range: nt,
  thumb: ot,
  noValue: it,
  sliderInput: rt
}, gt = ({
  className: e,
  label: t,
  shouldShowBackground: r = !1,
  shouldShowLabel: o = !1,
  size: a = "m",
  unit: l,
  withInputs: s = !1,
  ...i
}) => {
  const { max: c = 1 / 0, min: f = -1 / 0, onValueChange: y } = i, [n, u] = J(i.value || i.defaultValue || [0]), [S, C] = J([]);
  Q(() => {
    i.value && u(i.value);
  }, [i.value]), Q(() => {
    C(n.map((d) => String(d)));
  }, [n]);
  const _ = n && n.length <= 1 && n[0] === 0, p = he(), h = `${p}-output`, P = U(
    (d, v) => {
      var R;
      C((k) => {
        const V = [...k];
        return V[d] = v, V;
      });
      const B = parseInt(v, 10);
      if (isNaN(B))
        return;
      const { max: M = 1 / 0, min: A = -1 / 0 } = i, I = Math.max(A, Math.min(B, M));
      if (d === 0 && I > n[1] || d === 1 && I < n[0])
        return;
      const g = [...n];
      g[d] = I, g.some((k, V) => k !== n[V]) && (u(g), (R = i.onValueChange) == null || R.call(i, g));
    },
    [f, c, y, i, n]
  ), z = U(
    (d) => {
      const v = parseInt(S[d], 10), B = n[d === 0 ? 1 : 0], M = isNaN(v), A = v < (f ?? -1 / 0), I = v > (c ?? 1 / 0), g = d === 0 && v > B || d === 1 && v < B;
      M || A || I || g ? C((k) => {
        const V = [...k];
        return V[d] = String(n[d]), V;
      }) : P(d, String(v));
    },
    [S, n, f, c, P]
  ), b = U(
    (d) => {
      u(d), y == null || y(d);
    },
    [y]
  );
  return /* @__PURE__ */ H("div", { className: $(w.sliderWrapper, w[`size-${a}`]), "data-cxy-name": "slider", children: [
    o && /* @__PURE__ */ m("div", { className: w.labelContainer, children: /* @__PURE__ */ m(_e, { className: w.label, htmlFor: p, size: "s", children: t }) }),
    /* @__PURE__ */ H("div", { className: w.controlsWrapper, children: [
      /* @__PURE__ */ H(
        "div",
        {
          className: $(w.sliderContainer, {
            [w.shouldShowBackground]: r
          }),
          children: [
            /* @__PURE__ */ H(
              Ae,
              {
                id: p,
                ...!o && { "aria-label": t },
                "aria-describedby": h,
                className: $(w.slider, e),
                ...i,
                onValueChange: b,
                value: n,
                children: [
                  /* @__PURE__ */ m(Te, { className: w.track, children: /* @__PURE__ */ m(Ke, { className: w.range }) }),
                  n.map((d, v) => /* @__PURE__ */ xe(
                    $e,
                    {
                      ...!o && { "aria-label": t },
                      className: $(w.thumb, { [w.noValue]: _ }),
                      key: `${t}-thumb-${v}`
                    }
                  ))
                ]
              }
            ),
            !s && /* @__PURE__ */ H("p", { className: w.output, "data-testid": "slider-output", id: h, children: [
              n.map((d, v) => /* @__PURE__ */ m("span", { children: `${n[v]}${v === n.length - 1 ? "" : "-"}` }, `${t}-output-${v}`)),
              l || ""
            ] })
          ]
        }
      ),
      s && n.length === 2 && /* @__PURE__ */ H("div", { className: w.inputsContainer, children: [
        /* @__PURE__ */ m("div", { className: w.inputWrapper, children: /* @__PURE__ */ m(
          Z,
          {
            className: w.sliderInput,
            disabled: i.disabled,
            max: n[1],
            min: f,
            onBlur: () => z(0),
            onChange: (d) => P(0, d.target.value),
            type: "number",
            value: S[0] ?? ""
          }
        ) }),
        /* @__PURE__ */ m("div", { className: w.inputWrapper, children: /* @__PURE__ */ m(
          Z,
          {
            className: w.sliderInput,
            disabled: i.disabled,
            max: c,
            min: n[0],
            onBlur: () => z(1),
            onChange: (d) => P(1, d.target.value),
            type: "number",
            value: S[1] ?? ""
          }
        ) })
      ] })
    ] })
  ] });
};
export {
  gt as S
};
